export default "__VITE_ASSET__ia$PTtgP__"